import { SVGProps } from "react";

export const MinusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
    <g>
      <path
        d="M86.5 48.5h-83C1.567 48.5 0 46.933 0 45s1.567-3.5 3.5-3.5h83c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5z"
        transform="matrix(2.81 0 0 2.81 1.4066 1.4066)"
      />
      <path
        d="M86.5 48.5h-83C1.567 48.5 0 46.933 0 45s1.567-3.5 3.5-3.5h83c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5z"
        transform="matrix(2.81 0 0 2.81 1.4066 1.4066)"
      />
    </g>
  </svg>
);
